module.exports = __webpack_public_path__ + "static/img/drawer_icon.ab87b46a.png";